import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomersComponent } from './customers/customers.component';
import { NewCustomerComponent } from './new-customer/new-customer.component';
import { ToolbarModule } from '../toolbar/toolbar.module';
import { DataModule } from '../data/data.module';
import { GridModule } from '../grid/grid.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { InputModule } from '../input/input.module';
import { NotificationModule } from '../notification/notification.module';
import { CustomerService } from './customer.service';
import { MatDialogModule } from '@angular/material/dialog';
import { GridCellModule } from '@grid-cell/grid-cell.module';


@NgModule({
  declarations: [
    CustomersComponent,
    NewCustomerComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatFormFieldModule,
    MatDialogModule,
    MatIconModule,
    MatInputModule,
    MatSelectModule,
    ScrollingModule,
    //
    DataModule,
    GridModule,
    InputModule,
    NotificationModule,
    ToolbarModule,
    GridCellModule,
  ],
  exports: [
    CustomersComponent,
    NewCustomerComponent
  ],
  providers:[CustomerService]
})
export class CustomersModule { }
